import React from 'react';
import moment from 'moment';

const ChangeLogsTable = ({
    rows,
    paginationData,
    paginationState,
    setPaginationState,
}: {
    rows?: any;
    paginationData?: any;
    paginationState?: any;
    setPaginationState?: any
}) => {

    return (
        <div className=''>
            <div className='overflow-x-auto border border-1 !rounded-xl dark:border-borderColor-darkMode'>
                <table className='min-w-full bg-white dark:bg-black dark:text-primary-dark'>
                    <thead className='bg-white dark:bg-black text-left text-sm font-medium text-black dark:text-primary-dark rounded-xl'>
                        <tr>
                            <th className='px-4 py-3'>Timestamp</th>
                            <th className='px-4 py-3'>User</th>
                            <th className='px-4 py-3'>Template Name</th>
                            <th className='px-4 py-3'>Rule Name</th>
                            <th className='px-4 py-3'>Old Value</th>
                            <th className='px-4 py-3'>New Value</th>
                            <th className='px-4 py-3'>Reason/Note</th>
                        </tr>
                    </thead>
                    <tbody>
                        {(rows && rows?.length > 0) && rows?.map((row: any) => (
                            <tr key={row.id} className='hover:bg-gray-50 dark:hover:bg-bgColor-darkMode text-sm'>
                                <td className={`px-4 py-4`}>{moment(row?.timestamp).format('DD-MM-YYYY, hh:mm A')}</td>
                                <td className={`px-4 py-4`}>{row?.user?.name || row?.user?.email}</td>
                                <td className={`px-4 py-4`}>{row?.templateName || '--'}</td>
                                <td className={`px-4 py-4`}>{row?.ruleName || '--'}</td>
                                <td className={`px-4 py-4 text-[#EF4444]`}>{row?.oldValue}</td>
                                <td className={`px-4 py-4 text-[#10B981]`}>{row?.newValue}</td>
                                <td className={`px-4 py-4`}>{row?.reasonNote || '--'}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
            {paginationData &&
                (() => {
                    const currentPage = paginationData.number;
                    const totalPages = paginationData.totalPages;

                    const getPageList = () => {
                        const pageList: (number | string)[] = [];

                        if (totalPages <= 7) {
                            for (let i = 1; i <= totalPages; i++) {
                                pageList.push(i);
                            }
                        } else {
                            pageList.push(1);

                            if (currentPage > 3) {
                                pageList.push('...');
                            }

                            const start = Math.max(2, currentPage - 1);
                            const end = Math.min(totalPages - 1, currentPage + 1);

                            for (let i = start; i <= end; i++) {
                                pageList.push(i);
                            }

                            if (currentPage < totalPages - 2) {
                                pageList.push('...');
                            }

                            pageList.push(totalPages);
                        }

                        return pageList;
                    };

                    return (
                        <div className='flex justify-between items-center text-sm text-[#8F8F8F] dark:text-primary-dark px-5 py-2 mt-1 border-t border-[#DCDCDD]'>
                            {/* <div>
                                {paginationData.totalElements > 0 && (
                                    <span>
                                        {1 + ((currentPage - 1) * paginationData.size)}–
                                        {Math.min(currentPage * paginationData.size, paginationData.totalElements)} of {paginationData.totalElements} items
                                    </span>
                                )}
                            </div> */}
                            <div className='flex items-center gap-2'>
                                <button
                                    disabled={currentPage <= 1}
                                    onClick={() =>
                                        setPaginationState?.({ ...paginationState, pageNumber: currentPage - 1 })
                                    }
                                    className='hover:bg-gray-300 dark:hover:bg-black cursor-pointer px-2 py-1 rounded disabled:opacity-50'
                                >
                                    ◀
                                </button>

                                {getPageList().map((item, idx) => {
                                    if (typeof item === 'string') {
                                        return <span key={idx} className='px-2'>...</span>;
                                    }
                                    return (
                                        <button
                                            key={idx}
                                            onClick={() => setPaginationState?.({ ...paginationState, pageNumber: item })}
                                            className={`px-3 py-1 rounded transition-colors duration-200 ${item === currentPage ? 'bg-gray-400 text-white dark:bg-white dark:text-black' : 'hover:bg-gray-300 dark:hover:bg-black'}`}
                                        >
                                            {item}
                                        </button>
                                    );
                                })}

                                <button
                                    disabled={!paginationData?.hasNextPage}
                                    onClick={() =>
                                        setPaginationState?.({ ...paginationState, pageNumber: currentPage + 1 })
                                    }
                                    className='hover:bg-gray-300 dark:hover:bg-black cursor-pointer px-2 py-1 rounded disabled:opacity-50'
                                >
                                    ▶
                                </button>
                            </div>
                        </div>
                    );
                })()
            }
        </div>
    );
};

export default ChangeLogsTable;
